import Editor from '@zzzj/zzzj/src/components/ckeditor/editor';
import { MyUploadAdapter } from "@/components/editor/upload";
export default {
  name: "ck-editor-page",
  // model: {
  //   prop: 'modelVal',//指向props的参数名
  //   event: 'modelChange'//事件名称
  // },
  props: {
    defaultVal: {
      default: function _default() {
        return undefined;
      }
    },
    disabled: {
      default: function _default() {
        return false;
      }
    }
  },
  watch: {
    // defaultVal: {
    //   handler (val) {
    //     this.update(val);
    //   },
    //   immediate: true
    // },
  },
  components: {
    Editor: Editor
  },
  methods: {
    MyUploadAdapter: MyUploadAdapter,
    update: function update(val) {
      var editor = this.$refs.editor;
      if (editor) {
        editor.updateVal(val);
      }
    },
    getData: function getData() {
      var editor = this.$refs.editor;
      return editor.getData();
    },
    change: function change(val) {
      this.$emit('modelChange', val);
    }
  },
  data: function data() {
    return {
      value: undefined
    };
  }
};